import {
  Category,
  Chat,
  Folder,
  Message,
  Password,
  People,
  User,
  Work,
} from "react-iconly";

const pages = [
  {
    header: "UTAMA",
  },
  {
    id: "dashboard",
    title: "Dashboard",
    icon: <Category set="curved" className="remix-icon" />,
    navLink: "/dashboard",
    access: null,
  },
  {
    id: "chat",
    title: "Chat",
    icon: <Chat set="curved" className="remix-icon" />,
    navLink: "/chat",
    access: ["room-index", "room-show"],
  },
  {
    id: "archive",
    title: "Arsip Chat",
    icon: <Folder set="curved" className="remix-icon" />,
    navLink: "/archive",
    access: [],
  },
  {
    header: "LAINNYA",
  },
  {
    id: "system",
    title: "Sistem",
    icon: <Work set="curved" className="remix-icon" />,
    navLink: "/system/data",
    access: ["system-index", "system-show"],
  },
  {
    id: "user",
    title: "Manajemen User",
    icon: <People set="curved" className="remix-icon" />,
    navLink: "/user/data",
    access: ["user-index", "user-show"],
  },
  {
    id: "role",
    title: "Role & Permission",
    icon: <Password set="curved" className="remix-icon" />,
    navLink: "/role/data",
    access: ["role-index", "role-show"],
  },
  {
    id: "profile",
    title: "Profile",
    icon: <User set="curved" className="remix-icon" />,
    navLink: "/profile/my-profile",
    access: null,
  },
];

export default pages;
